// extracted by mini-css-extract-plugin
export default {"verticalDivider":"queueDashboardPage_verticalDivider__SD0Dr"};